import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  CommonModule,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
// import { SettingsMenuComponent } from './component/settings-menu/settings-menu.component';

// angular material
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// DW service
import {
  ApiService,
  CommonLib,
  ValidationCheckService,
  JsonService,
} from 'src/common/dw_service';
import { DwGoogleApi } from './providers/dmp.googleapi.service';
import { DWNavigationService } from 'src/common/dw_navigation_service';

// page component
// import { TopComponent } from './pages/top/top.component';
import { ModalComponent } from './component/modal/modal.component';
import { ModalEventNoticeComponent } from 'src/app/component/modal-event-notice/modal-event-notice.component';
import { ModalEventQrComponent } from 'src/app/component/modal-event-qr/modal-event-qr.component';

@NgModule({ declarations: [
        AppComponent,
        ModalComponent,
        ModalEventNoticeComponent,
        ModalEventQrComponent,
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        ReactiveFormsModule,
        AppRoutingModule,
        RouterModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatRadioModule,
        // SettingsMenuComponent,
        MatFormFieldModule,
        MatInputModule], providers: [
        // {
        //   provide: LocationStrategy,
        //   useClass: PathLocationStrategy
        // },
        ApiService,
        CommonLib,
        ValidationCheckService,
        JsonService,
        DwGoogleApi,
        DWNavigationService,
        {
            provide: MatDialogRef,
            useValue: {},
        },
        {
            provide: MAT_DIALOG_DATA,
            useValue: {},
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
